<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="List Group" pageTitle="List Group" />
            <ListGroup />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ListGroup from '../ListGroup/ListGroup'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ListGroupPage',
    components: {
        MainHeader,
        PageTitle,
        ListGroup,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>